$(document).on('click', '.js-hidable-row-toggle', function(e) {
  $(this).next('.js-hidable-row').toggleClass('hidden');
});
